/**
 * THIS FILE IS AUTO-GENERATED by GraphQL Code Generator.
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * Source: module-flash-sale/src/api/gql/voucher.gateway.graphql
 * Schema: Federation Gateway (Marketing Service)
 *
 * Run codegen:
 *   GRAPHQL_GATEWAY_URL=<gateway-url> npx graphql-codegen --config codegen.yml
 */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
const defaultOptions = {} as const;

// ─── Scalar Types ─────────────────────────────────────────────────────────────

export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    DateTime: { input: string; output: string };
    JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
};

// ─── Enum Types ───────────────────────────────────────────────────────────────

export enum MarketingCodeType {
    VOUCHER = 'VOUCHER',
    COUPON = 'COUPON',
}

export enum VoucherDisplayType {
    ALLOCATION = 'ALLOCATION',
    MANUAL = 'MANUAL',
}

export enum DisplayLocation {
    CART = 'CART',
    CHECKOUT = 'CHECKOUT',
    MY_VOUCHERS = 'MY_VOUCHERS',
}

// ─── Object Types ─────────────────────────────────────────────────────────────

export type StorefrontAllocation = {
    __typename?: 'StorefrontAllocation';
    id: Scalars['ID']['output'];
    allocation_code: Scalars['String']['output'];
    name: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    start_at?: Maybe<Scalars['DateTime']['output']>;
    expires_at?: Maybe<Scalars['DateTime']['output']>;
    display_locations?: Maybe<Array<Scalars['String']['output']>>;
    remaining_user_quota?: Maybe<Scalars['Int']['output']>;
    remaining_allocation_quota?: Maybe<Scalars['Int']['output']>;
    sample_amount?: Maybe<Scalars['Float']['output']>;
    magento_conditions?: Maybe<Scalars['JSON']['output']>;
    magento_pool_id?: Maybe<Scalars['String']['output']>;
};

export type AppliedCodeData = {
    __typename?: 'AppliedCodeData';
    type: MarketingCodeType;
    voucher_id?: Maybe<Scalars['String']['output']>;
    allocation_name?: Maybe<Scalars['String']['output']>;
    masked_code?: Maybe<Scalars['String']['output']>;
    applied_amount?: Maybe<Scalars['Float']['output']>;
    coupon_code?: Maybe<Scalars['String']['output']>;
    discount_label?: Maybe<Scalars['String']['output']>;
};

export type ApplyCodeResponse = {
    __typename?: 'ApplyCodeResponse';
    success: Scalars['Boolean']['output'];
    error_message?: Maybe<Scalars['String']['output']>;
    data?: Maybe<AppliedCodeData>;
};

export type MarketingAppliedCoupon = {
    __typename?: 'MarketingAppliedCoupon';
    code: Scalars['String']['output'];
    discount_label?: Maybe<Scalars['String']['output']>;
};

export type AppliedVoucher = {
    __typename?: 'AppliedVoucher';
    voucher_id: Scalars['String']['output'];
    display_name: Scalars['String']['output'];
    display_type: VoucherDisplayType;
    applied_amount: Scalars['Float']['output'];
    allocation_name?: Maybe<Scalars['String']['output']>;
    allocation?: Maybe<StorefrontAllocation>;
};

export type AppliedCodesResponse = {
    __typename?: 'AppliedCodesResponse';
    coupons: Array<MarketingAppliedCoupon>;
    vouchers: Array<AppliedVoucher>;
};

export type RemoveCodeResponse = {
    __typename?: 'RemoveCodeResponse';
    success: Scalars['Boolean']['output'];
    error_message?: Maybe<Scalars['String']['output']>;
};

export type ApplyVoucherResponse = {
    __typename?: 'ApplyVoucherResponse';
    success: Scalars['Boolean']['output'];
    voucher_id?: Maybe<Scalars['String']['output']>;
    error_message?: Maybe<Scalars['String']['output']>;
};

// ─── Query Variable & Result Types ───────────────────────────────────────────

export type MarketingGetAvailableVouchersQueryVariables = Exact<{
    location?: InputMaybe<DisplayLocation>;
    cart_id?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarketingGetAvailableVouchersQuery = {
    __typename?: 'Query';
    marketingGetAvailableVouchers: Array<StorefrontAllocation>;
};

export type MarketingGetAppliedCodesQueryVariables = Exact<{
    cart_id: Scalars['String']['input'];
}>;

export type MarketingGetAppliedCodesQuery = {
    __typename?: 'Query';
    marketingGetAppliedCodes: AppliedCodesResponse;
};

export type MarketingGetAllocationDetailQueryVariables = Exact<{
    allocation_id: Scalars['String']['input'];
}>;

export type MarketingGetAllocationDetailQuery = {
    __typename?: 'Query';
    marketingGetAllocationDetail?: Maybe<StorefrontAllocation>;
};

// ─── Mutation Variable & Result Types ─────────────────────────────────────────

export type MarketingApplyCodeMutationVariables = Exact<{
    code: Scalars['String']['input'];
    cart_id: Scalars['String']['input'];
}>;

export type MarketingApplyCodeMutation = {
    __typename?: 'Mutation';
    marketingApplyCode: ApplyCodeResponse;
};

export type MarketingRemoveCodeMutationVariables = Exact<{
    code_id: Scalars['String']['input'];
    type: MarketingCodeType;
    cart_id: Scalars['String']['input'];
}>;

export type MarketingRemoveCodeMutation = {
    __typename?: 'Mutation';
    marketingRemoveCode: RemoveCodeResponse;
};

export type MarketingApplyVoucherFromAllocationMutationVariables = Exact<{
    allocation_id: Scalars['String']['input'];
    cart_id: Scalars['String']['input'];
}>;

export type MarketingApplyVoucherFromAllocationMutation = {
    __typename?: 'Mutation';
    marketingApplyVoucherFromAllocation: ApplyVoucherResponse;
};

export type MarketingRemoveAppliedVoucherMutationVariables = Exact<{
    voucher_id: Scalars['String']['input'];
    cart_id: Scalars['String']['input'];
}>;

export type MarketingRemoveAppliedVoucherMutation = {
    __typename?: 'Mutation';
    marketingRemoveAppliedVoucher: ApplyVoucherResponse;
};

// ─── Document Nodes ───────────────────────────────────────────────────────────

export const MarketingGetAvailableVouchersDocument = gql`
    query MarketingGetAvailableVouchers($location: DisplayLocation, $cart_id: String) {
        marketingGetAvailableVouchers(location: $location, cart_id: $cart_id) {
            id
            allocation_code
            name
            description
            start_at
            expires_at
            display_locations
            remaining_user_quota
            remaining_allocation_quota
            sample_amount
            magento_conditions
        }
    }
`;

export function useMarketingGetAvailableVouchersQuery(
    baseOptions?: Apollo.QueryHookOptions<
        MarketingGetAvailableVouchersQuery,
        MarketingGetAvailableVouchersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<MarketingGetAvailableVouchersQuery, MarketingGetAvailableVouchersQueryVariables>(
        MarketingGetAvailableVouchersDocument,
        options
    );
}

export function useMarketingGetAvailableVouchersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        MarketingGetAvailableVouchersQuery,
        MarketingGetAvailableVouchersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<MarketingGetAvailableVouchersQuery, MarketingGetAvailableVouchersQueryVariables>(
        MarketingGetAvailableVouchersDocument,
        options
    );
}

export const MarketingGetAppliedCodesDocument = gql`
    query MarketingGetAppliedCodes($cart_id: String!) {
        marketingGetAppliedCodes(cart_id: $cart_id) {
            coupons {
                code
                discount_label
            }
            vouchers {
                voucher_id
                display_name
                display_type
                applied_amount
                allocation_name
                allocation {
                    id
                    allocation_code
                    name
                    description
                    start_at
                    expires_at
                    display_locations
                    remaining_user_quota
                    remaining_allocation_quota
                    sample_amount
                    magento_pool_id
                    magento_conditions
                }
            }
        }
    }
`;

export function useMarketingGetAppliedCodesQuery(
    baseOptions: Apollo.QueryHookOptions<MarketingGetAppliedCodesQuery, MarketingGetAppliedCodesQueryVariables> &
        ({ variables: MarketingGetAppliedCodesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<MarketingGetAppliedCodesQuery, MarketingGetAppliedCodesQueryVariables>(
        MarketingGetAppliedCodesDocument,
        options
    );
}

export function useMarketingGetAppliedCodesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MarketingGetAppliedCodesQuery, MarketingGetAppliedCodesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<MarketingGetAppliedCodesQuery, MarketingGetAppliedCodesQueryVariables>(
        MarketingGetAppliedCodesDocument,
        options
    );
}

export const MarketingGetAllocationDetailDocument = gql`
    query MarketingGetAllocationDetail($allocation_id: String!) {
        marketingGetAllocationDetail(allocation_id: $allocation_id) {
            id
            allocation_code
            name
            description
            start_at
            expires_at
            display_locations
            remaining_user_quota
            remaining_allocation_quota
            sample_amount
        }
    }
`;

export function useMarketingGetAllocationDetailQuery(
    baseOptions: Apollo.QueryHookOptions<
        MarketingGetAllocationDetailQuery,
        MarketingGetAllocationDetailQueryVariables
    > &
        ({ variables: MarketingGetAllocationDetailQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<MarketingGetAllocationDetailQuery, MarketingGetAllocationDetailQueryVariables>(
        MarketingGetAllocationDetailDocument,
        options
    );
}

export const MarketingApplyCodeDocument = gql`
    mutation MarketingApplyCode($code: String!, $cart_id: String!) {
        marketingApplyCode(code: $code, cart_id: $cart_id) {
            success
            error_message
            data {
                type
                voucher_id
                allocation_name
                masked_code
                applied_amount
                coupon_code
                discount_label
            }
        }
    }
`;

export type MarketingApplyCodeMutationFn = Apollo.MutationFunction<
    MarketingApplyCodeMutation,
    MarketingApplyCodeMutationVariables
>;

export function useMarketingApplyCodeMutation(
    baseOptions?: Apollo.MutationHookOptions<MarketingApplyCodeMutation, MarketingApplyCodeMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<MarketingApplyCodeMutation, MarketingApplyCodeMutationVariables>(
        MarketingApplyCodeDocument,
        options
    );
}

export const MarketingRemoveCodeDocument = gql`
    mutation MarketingRemoveCode($code_id: String!, $type: MarketingCodeType!, $cart_id: String!) {
        marketingRemoveCode(code_id: $code_id, type: $type, cart_id: $cart_id) {
            success
            error_message
        }
    }
`;

export type MarketingRemoveCodeMutationFn = Apollo.MutationFunction<
    MarketingRemoveCodeMutation,
    MarketingRemoveCodeMutationVariables
>;

export function useMarketingRemoveCodeMutation(
    baseOptions?: Apollo.MutationHookOptions<MarketingRemoveCodeMutation, MarketingRemoveCodeMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<MarketingRemoveCodeMutation, MarketingRemoveCodeMutationVariables>(
        MarketingRemoveCodeDocument,
        options
    );
}

export const MarketingApplyVoucherFromAllocationDocument = gql`
    mutation MarketingApplyVoucherFromAllocation($allocation_id: String!, $cart_id: String!) {
        marketingApplyVoucherFromAllocation(allocation_id: $allocation_id, cart_id: $cart_id) {
            success
            voucher_id
            error_message
        }
    }
`;

export type MarketingApplyVoucherFromAllocationMutationFn = Apollo.MutationFunction<
    MarketingApplyVoucherFromAllocationMutation,
    MarketingApplyVoucherFromAllocationMutationVariables
>;

export function useMarketingApplyVoucherFromAllocationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MarketingApplyVoucherFromAllocationMutation,
        MarketingApplyVoucherFromAllocationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        MarketingApplyVoucherFromAllocationMutation,
        MarketingApplyVoucherFromAllocationMutationVariables
    >(MarketingApplyVoucherFromAllocationDocument, options);
}

export const MarketingRemoveAppliedVoucherDocument = gql`
    mutation MarketingRemoveAppliedVoucher($voucher_id: String!, $cart_id: String!) {
        marketingRemoveAppliedVoucher(voucher_id: $voucher_id, cart_id: $cart_id) {
            success
            voucher_id
            error_message
        }
    }
`;

export type MarketingRemoveAppliedVoucherMutationFn = Apollo.MutationFunction<
    MarketingRemoveAppliedVoucherMutation,
    MarketingRemoveAppliedVoucherMutationVariables
>;

export function useMarketingRemoveAppliedVoucherMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MarketingRemoveAppliedVoucherMutation,
        MarketingRemoveAppliedVoucherMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<MarketingRemoveAppliedVoucherMutation, MarketingRemoveAppliedVoucherMutationVariables>(
        MarketingRemoveAppliedVoucherDocument,
        options
    );
}
